import React from 'react';
import { formatThousands, parseDigits } from '../utils/currency';

interface RupiahInputProps {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  darkMode?: boolean;
  id?: string;
  size?: 'sm' | 'md';
}

/** Numeric Rupiah input with "Rp" prefix and automatic thousand separators. */
const RupiahInput: React.FC<RupiahInputProps> = ({
  value, onChange, placeholder = '0', className = '', disabled, darkMode, id, size = 'md',
}) => {
  const pad = size === 'sm' ? 'pl-8 pr-2 py-1 text-sm' : 'pl-11 pr-4 py-2';
  return (
    <div className={`relative ${className}`}>
      <span className={`absolute inset-y-0 left-0 flex items-center ${size === 'sm' ? 'pl-2 text-xs' : 'pl-4 text-sm'} font-medium pointer-events-none ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        Rp
      </span>
      <input
        id={id}
        type="text"
        inputMode="numeric"
        value={formatThousands(value ?? null)}
        onChange={(e) => onChange(parseDigits(e.target.value))}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full ${pad} border rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent tabular-nums ${
          darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'border-gray-300 text-gray-900'
        } disabled:opacity-50 disabled:cursor-not-allowed`}
      />
    </div>
  );
};

export default RupiahInput;
